import { TreeGroup } from "./TreeGroup";
import { TreeItem } from "./TreeItem";

export const Tree = {
  Group: TreeGroup,
  Item: TreeItem,
};

export type { TreeGroupProps } from "./TreeGroup";
export type { TreeItemProps } from "./TreeItem";
